module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section section-white"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-header"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleGenderUser
    },
    model: {
      value: (_vm.gender.currentUserType),
      callback: function($$v) {
        _vm.$set(_vm.gender, "currentUserType", $$v)
      },
      expression: "gender.currentUserType"
    }
  }, _vm._l((_vm.user), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleGenderDate
    },
    model: {
      value: (_vm.gender.date),
      callback: function($$v) {
        _vm.$set(_vm.gender, "date", $$v)
      },
      expression: "gender.date"
    }
  }, _vm._l((_vm.date), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "content-padded-b"
  }, [_c('canvas', {
    attrs: {
      "id": "gender-doughnut"
    }
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('canvas', {
    attrs: {
      "id": "gender-bar"
    }
  })])], 1)], 1)]), _vm._v(" "), _c('section', {
    staticClass: "section section-white"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section-header"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleAreaUser
    },
    model: {
      value: (_vm.area.currentUserType),
      callback: function($$v) {
        _vm.$set(_vm.area, "currentUserType", $$v)
      },
      expression: "area.currentUserType"
    }
  }, _vm._l((_vm.user), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleAreaDate
    },
    model: {
      value: (_vm.area.date),
      callback: function($$v) {
        _vm.$set(_vm.area, "date", $$v)
      },
      expression: "area.date"
    }
  }, _vm._l((_vm.date), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('section', {
    staticClass: "section section-white"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "section-header"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleTerminalUser
    },
    model: {
      value: (_vm.terminal.currentUserType),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "currentUserType", $$v)
      },
      expression: "terminal.currentUserType"
    }
  }, _vm._l((_vm.user), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleTerminalDate
    },
    model: {
      value: (_vm.terminal.date),
      callback: function($$v) {
        _vm.$set(_vm.terminal, "date", $$v)
      },
      expression: "terminal.date"
    }
  }, _vm._l((_vm.date), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "content-padded-b"
  }, [_c('canvas', {
    attrs: {
      "id": "terminal-doughnut"
    }
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "content-padded-b"
  }, [_c('canvas', {
    attrs: {
      "id": "model-doughnut"
    }
  })])])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("性别及年龄分布")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("地区分布")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-body"
  }, [_c('canvas', {
    attrs: {
      "id": "area-bar"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("终端及机型分布")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c07bf6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c07bf6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/statistics/dataanalysis/user.vue
// module id = 2803
// module chunks = 0